import React, { PureComponent } from 'react';

import { withRouter } from 'react-router-dom';
import omit from 'lodash/omit';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import classnames from 'classnames';
import { connect } from 'react-redux';

import { updateAsset, requestUpdateAsset } from 'containers/assets/actions';
import { addGrowlMessage as addMsg } from 'messages/actions';
import { Form } from 'common/components';
import AssetsForm from 'components/assets/form_sections';
import AssetsFormHandlers from 'containers/assets/AssetsFormHandlers';
import { createRoute } from 'lib/util';

class AssetsEditFilesView extends PureComponent {
  static propTypes = {
    addMsg: PropTypes.func.isRequired,
    updateAsset: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
  };

  checkLimit = (callback) => (e) => {
    let { addMsg, asset, company } = this.props;
    const { filesPerAsset, sizePerFile } = company;
    const { _files } = asset;

    console.log('%c ' + _files.length, 'background: #222; color: #bada55');

    console.log('%c ' + 'Agregara', 'background: #222; color: #bada55');
    if (_files.length > filesPerAsset) {
      e.preventDefault();
      // console.log("Excedio el limite");
      console.log('%c ' + 'No puede agregar', 'background: #222; color: #bada55');
      addMsg('error.asset.files_limit_exceded', 'error', 'common.error');
      return false;
    } else {
      console.log('%c ' + 'Puede agregar', 'background: #222; color: #bada55');
      callback(e);
      // return true
    }
  };

  handleSubmit = (e) => {
    let { addMsg, asset, company, history, subcompany, updateAsset, requestUpdateAsset } =
      this.props;

    const aId = asset.id;
    const cId = company.id;
    const sId = subcompany.id;

    asset = omit(asset, [
      '_fiscalDepreciationResult',
      '_financialDepreciationResult',
      '_extraDepreciationsResult',
    ]);

    const isRequest = !!this.props.match.params.isRequest;
    const method = isRequest ? requestUpdateAsset : updateAsset;

    method(aId, cId, sId, asset).then(({ value }) => {
      addMsg(value.message, 'success', 'common.success');
      history.push(`/companies/${cId}/subcompanies/${sId}/assets`);
    });
  };

  render = () => {
    // console.log('%c ' + "asdasd" + 'background: #222; color: #bada55');
    // console.log('%c ' + JSON.stringify(this.props.company), 'background: #222; color: #bada55');
    // console.log('%c ' + JSON.stringify(this.props.asset), 'background: #222; color: #bada55');
    // console.log('%c ' + this.props.company.filesPerAsset, 'background: #222; color: #bada55');
    console.log('%c ' + this.props.asset._files.length, 'background: #222; color: #bada55');

    return (
      <AssetsFormHandlers
        render={({
          files,
          uploadFiles,
          handleFileAdd,
          handleFileChange,
          handleFileRemove,
          handleFileUploadedRemove,
          isSubmitted,
          isSaving,
        }) => (
          // <form onSubmit={(e) => {
          //   uploadFiles(this.handleSubmit(e));
          //   console.log('%c ' + 'Pasa por aqui', 'background: #222; color: #bada55');

          //   if (this.checkLimit(e)) {
          //     console.log('%c ' + 'Permitio', 'background: #222; color: #bada55');
          //   } else {
          //     e.preventDefault();
          //     console.log('%c ' + 'No permitio', 'background: #222; color: #bada55');

          //   }
          // }} noValidate autoComplete="false">
          <form onSubmit={uploadFiles(this.handleSubmit)} noValidate autoComplete="false">
            <div className="col-12 bbottom mb-3 mt-3">
              <AssetsForm.Files
                uploaded={this.props.asset._files}
                files={files}
                handleFileAdd={handleFileAdd}
                handleFileChange={handleFileChange}
                handleFileRemove={handleFileRemove}
                handleFileUploadedRemove={handleFileUploadedRemove}
                addMsg={this.props.addMsg}
              />
            </div>
            <div className="col-md-12 mt-3">
              <Form.Button
                type={'submit'}
                text={this.props.t('actions.save')}
                isLoading={isSaving}
                disabled={isSaving}
                extraClassName={'pull-right btn-xs-block'}
              />

              <Form.Link
                to={createRoute(this.props.company.id, this.props.subcompany.id, 'assets')}
                className={classnames('btn btn-secondary pull-right mr-3', {
                  disabled: isSaving,
                })}
              >
                {this.props.t('actions.cancel')}
              </Form.Link>
              <div className="clearfix" />
            </div>
          </form>
        )}
      />
    );
  };
}

const mapStateToProps = () => ({});
const mapDispatchToProps = { updateAsset, addMsg, requestUpdateAsset };

export default withRouter(
  translate()(connect(mapStateToProps, mapDispatchToProps)(AssetsEditFilesView))
);



// WEBPACK FOOTER //
// src/containers/assets/edit_sections/AssetsEditFilesSection.js